export const COPIES = {
  NO_BOX_NO_LABEL: {
    TITLE: 'Paperless Packing Service',
    DESCRIPTION:
      'At a supported carrier facility, shoppers can bring items and a barcode to have their items packed and labeled. Shoppers may be required to pay for packaging services.'
  },
  PAPERLESS: {
    TITLE: 'Paperless',
    DESCRIPTION:
      'Customer will receive a barcode and will have to carry it along with the packaged items to the UPS drop-off location. The UPS executive will print the label for the shipment.'
  }
};
